import Vue from "vue";
import initialData from "~/mixins/initial-state";

Vue.mixin(initialData);



// WEBPACK FOOTER //
// ./resources/js/services/initial-state.js